export default {
	"PageLoading.WeChatCanEnterTheAccessAfterAuthorizationRequestAuthorization": "微信授權後可進入訪問，請求授權中···",
	"PageLoading.OhWellSomethingWentWrong": "哦哦，出錯了！",
	"PageLoading.ShoutingIsComing": "叫叫正在趕來..."
}